import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { BackStyle } from "./Loading.style";
import LoadingPartCM from "../PartLoading";

function SkeletonCM(props) {
  return (
    <>
      {props.BackWrapper ? (
        <BackStyle>
          <LoadingPartCM />
        </BackStyle>
      ) : (
        ""
      )}
      <Skeleton
        count={props.Count ? props.Count : 1}
        height={props.Height ? props.Height : 50}
        width={props.Width ? props.Width : "100%"}
        circle={props.Circle ? true : false}
        inline={props.Inline ? true : false}
        style={{
          marginLeft: props.mLeft ? props.mLeft : "0",
          marginTop: props.mTop ? props.mTop : "0",
          marginRight: props.mRight ? props.mRight : "0",
          marginBottom: props.mBottom ? props.mBottom : "0",
        }}
      />
    </>
  );
}

export default SkeletonCM;
